module.exports = __webpack_public_path__ + "static/media/cliente.e2881ea3.jpg";